import React from "react";
import { Container } from "@chakra-ui/react";
import ListLiveChannel from "views/admin/LiveTV/components/ListLiveChannel";

const LiveTV = () => {
  return (
    <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }}>
      <ListLiveChannel />
    </Container>
  );
};

export default LiveTV;
